<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 md10 lg8>
        <barcode
          title="Repair Orders"
          subtitle="Scan or Enter a Serial Number"
          buttonText="Search Repairs"
          @search="searchRepairs"
          @cleared="handleCleared"
          ref="barcodeComponent"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Barcode from "@/components/app/Barcode";

export default {
  name: "repair-barcode",
  data() {
    return {
      dialog: false
    };
  },

  components: {
    Barcode
  },

  mixins: [LoginCheck],

  watch: {
    dialog(val) {
      if (!val) this.handleCleared();
    }
  },

  computed: {
    ...mapGetters({
      repair: "repair/getRepair"
    }),
    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      } else if (this.$vuetify.breakpoint.sm) {
        return "80%";
      } else return "70%";
    }
  },

  methods: {
    ...mapActions({
      repairSearch: "repair/searchServices"
    }),
    async searchRepairs(barcodeValue) {
      await this.repairSearch({ serial: barcodeValue.trim() });

      if (this.repair.length) {
        this.$router.push(`/repair/${barcodeValue.trim()}`);
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: "No repair order found!",
          color: "red"
        });
      }
    },

    handleCleared() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$refs.barcodeComponent.focusBarcode();
    }
  }
};
</script>

<style>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
